// Configuration for different environments
const isDevelopment = process.env.NODE_ENV === 'development' || !process.env.NODE_ENV;

const config = {
  // API URLs
  apiUrl: isDevelopment 
    ? 'http://localhost:5000' 
    : process.env.REACT_APP_API_URL || 'https://yourdomain.com',
  
  // Backend URL
  backendUrl: isDevelopment
    ? 'http://localhost:5000/api'
    : process.env.REACT_APP_BACKEND_URL || 'https://yourdomain.com/api',
  
  // Environment
  environment: process.env.NODE_ENV || 'development',
  
  // Feature flags
  features: {
    googleAuth: true,
    facebookAuth: false, // Enable when ready
    appleAuth: false,    // Enable when ready
  }
};

export default config;
